const locales = {
    ACCOUNT: 'Compte',
    ACCOUNT_DONT_HAVE_SPE: 'Le compte fournis n\'a pas le module spe',
    ACCOUNT_FILLING: 'Remplissage',
    ACCOUNT_NOT_FOUND: 'Compte non trouvé',
    ACCOUNTS: 'Comptes',
    ACCOUNTS_MANAGER: 'Gestion des comptes',
    ACTION_TYPE: 'Type d\'action',
    ACTIONS: 'Actions',
    ACTIVITY: 'Activité',
    ADD_ACCOUNT: 'Créer un compte',
    ADD_CATALOG: 'Ajouter un catalogue',
    ADD_EMAIL: 'Ajouter un email',
    ADD_NEW_URL_INPUT: 'Ajouter une nouvelle URL',
    ADD_PERFORMANCE: 'Ajouter une performance',
    ADD_PROXY: 'Ajouter un proxy',
    ADD_SITE: 'Ajouter un site',
    ADD_SITES_TO_SCRAP: 'Ajouter des sites à scraper',
    ADD_SLIDER_CONFIG_FOR: 'Ajouter une config slider pour {siteName}',
    ADD_SPE_CONFIG_FOR: 'Ajouter une config SPE pour {siteName}',
    ADD_USER: 'Créer un utilisateur',
    ADVANCED_PARAMETERS: 'Paramètres avancés',
    ADVANCED_PARAMETERS_SUBTITLE: 'Cette fenêtre vous permet de modifier le temps d\'attente avant l\'éxecution du script (vitesse du site ↘ temps d\'attente ↗), et d\'ajouter un proxy qui sera utilisé pour aller sur les différentes URLs.',
    ALPHABETICAL_ORDER: 'Ordre alphabétique',
    ALTERNATIVE_URL: 'Url alternative',
    ANALYZE: 'Analyse',
    AND: 'et',
    ANTI_ALPHABETICAL_ORDER: 'Ordre anti-alphabétique',
    ANTI_CHRONOLOGICAL_ORDER: 'Ordre anti-chonologique',
    ARTICLE_ATTRIBUTE: 'Attribut d\'article',
    ARTICLE_MATCH_RULE: 'Article en entrée avec au moins un match en base',
    ASCENDING_ORDER: 'Ordre croissant',
    ASIN: 'ASIN',
    ATTRIBUTE: 'Attribut',
    ATTRIBUTE_OPTIONAL: 'Attribut optionnel',
    ATTRIBUTE_REQUIRED: 'Attribut requis',
    BACK: 'Retour',
    BAD_PROXY: 'Mauvais proxy',
    BOT_VERSION: 'Version du Bot',
    BRAND: 'Marque',
    CANCEL: 'Annuler',
    CATALOG: 'Catalogue',
    CATALOG_ADD_SUBTITLE: 'Cette fenêtre vous permet d\'ajouter un catalogue, en renseignant son nom, le délai entre ses mises à jour, et son activité.',
    CATALOG_DELETE_SUBTITLE: 'Cette fenêtre vous permet de supprimer un catalogue.',
    CATALOG_INFORMATION_SUBTITLE: 'Voici les informations de la dernière mise à jour de {catalogName} :',
    CATALOG_MINIMUM_DELAY: 'Le délai minimum est de 1 semaine',
    CATALOG_NAME: 'Nom du catalogue',
    CATALOG_PARAM_SUBTITLE: 'Cette fenêtre vous permet de modifier le nom d\'un catalogue, le délai entre ses mises à jours, et son activité.',
    CATALOG_SCRIPT_NAME: 'Nom du script catalogue',
    CATALOG_UPDATE: 'CatalogUpdater',
    CATALOG_UPDATE_ACTIVATED: 'Mise à jour automatique activée',
    CATALOG_UPDATE_DISABLED: 'Mise à jour automatique désactivée',
    CATALOGS: 'Catalogues',
    CATEGORY: 'Category',
    CATEGORY_ID: 'Category',
    CATEGORY_NAME: 'Category',
    CHANGE_PASSWORD: 'Changer le mot de passe',
    CHANGE_PASSWORD_DISCLAIMER: 'Êtes vous sûr de vouloir changer votre mot de passe ?',
    CHANGE_USERNAME: 'Changer le nom d\'utilisateur',
    CHANGE_USERNAME_DISCLAIMER: 'Êtes vous sûr de vouloir changer votre nom d\'utilisateur ?',
    CHECK_ALL: 'Tout sélectionner',
    CHOOSE_A_DELAY: 'Choisir un délais',
    CHOOSE_COUNTRY: 'Choisir un pays',
    CHRONOLOGICAL_ORDER: 'Ordre chronologique',
    CLOSE: 'Fermer',
    CMS_LAST_KNOWN_STOCK: 'CMS STOCK',
    CMS_PRODUCT_ID: 'CMS ID',
    COLOR: 'Couleur',
    COMMENT: 'Commentaire',
    CONFIGURATION_SLIDER: 'Slider Configuration',
    CONFIGURATION_SPE: 'SPE Configuration',
    CONFIGURED_SITES: 'Sites configurés',
    CONFIRM: 'Confirmer',
    CONFIRM_PASSWORD: 'Confirmation mot de passe',
    CONFIRM_SITE_ADBOX_CONFIG: 'Attention vous avez du texte non ajouté à la liste des emails, voulez vous l\'ajouter?',
    CONFIRMATION_CATALOG_DELETE_DISCLAIMER: 'Êtes vous sûr de vouloir supprimer {catalogName} ? Cette action est irreversible :',
    CONFIRMATION_DELETE_SITE_FROM_ACCOUNT: 'Voulez vous vraiment supprimer le site {siteToDelete} du compte {accountName} ?',
    CONFIRMATION_UPDATE_ACCOUNT: 'Êtes vous sur de vouloir modifier {accountName} ? Cette action est irreversible et les données des sites modifiés vont être supprimées.',
    CONTROL_TOWER: 'Tour de contrôle',
    COPY_TO_CLIPBOARD: 'Copier dans le presse-papier',
    COUNTRY: 'Pays',
    CURRENCY: 'Devise',
    CURRENT_PASSWORD: 'Mot de passe actuel',
    DAILY_RECAP: 'DailyRecap',
    DASHBOARD: 'DashBoard',
    DATA_SAMPLE: 'Exemple de données',
    DATE: 'Date',
    DAY: 'Jours',
    DAYS: 'Jours',
    DEFAULT_FILTERS: 'Filtres par défaut',
    DEFAULT_SETTINGS: 'Paramètres par défauts',
    DELAY: 'Délai',
    DELETE: 'Supprimer',
    DELETE_CATALOG: 'Supprimer un catalogue',
    DELETE_PROXY: 'Supprimer un proxy',
    DESCENDING_ORDER: 'Ordre décroissant',
    DISABLE_AUTOMATIC_CATALOG_UPDATE: 'Désactiver la mise à jour automatique du catalogue',
    DISCONNECTED: 'Vous avez été déconnecté',
    DISPLAY_DONE_ROW: 'Afficher les lignes déjà faites',
    DISPLAY_PENDING_ONLY: 'Seulement les PENDING',
    DOWNLOAD: 'Télécharger',
    DOWNLOAD_DIALOG_DEFINITION: 'Pour télécharger ce script, entrer un nom de fichier et cliquer sur le bouton de téléchargement.',
    DROP_HERE: 'Déposer ici',
    DUPLICATE: 'Dupliquer',
    DUPLICATE_ACCOUNT: 'Dupliquer le compte {name}',
    EAN: 'EAN',
    EDIT_ACCOUNT: 'Modifier un compte',
    EDIT_PRICE: 'Editer le prix',
    EDIT_PROXY: 'Editer le proxy',
    EDIT_SITE: 'Editer un site',
    EDIT_URL: 'Editer l\'url',
    EDIT_USER: 'Editer un utilisateur',
    EMAIL: 'Email',
    EMPTY: 'Vide',
    ENABLE_AUTOMATIC_CATALOG_UPDATE: 'Activer la mise à jour automatique du catalogue',
    ENTER_YOUR_CURRENT_PASSWORD: 'Veuillez entrer votre mot de passe actuel',
    ENTER_YOUR_NEW_PASSWORD: 'Veuillez entrer votre nouveau mot de passe',
    ENTER_YOUR_NEW_USERNAME: 'Veuillez entrer votre nouveau nom d\'utilisateur',
    ERROR: 'Erreur',
    ERROR_ADD_ACCOUNT: 'Une erreur est survenu lors de l\'ajout du compte',
    ERROR_ADD_CATEGORY: 'Une erreur est survenu lors de l\'ajout des catégories',
    ERROR_ADD_PERFORMANCE: 'Une erreur est survenu lors de l\'ajout de la performance',
    ERROR_ADD_SITE: 'Une erreur est survenu lors de l\'ajout du site',
    ERROR_ADD_USER: 'Une erreur est survenu lors de l\'ajout de l\'utilisateur',
    ERROR_DATA_EXPORT: 'Aucune données à exporter',
    ERROR_DELETE_PERFORMANCE: 'Une erreur est survenu lors de la suppression de la performance',
    ERROR_DIFF_IMPORT: 'Il y a eu une erreur lors de l\'import, contactez le support technique via Slack.',
    ERROR_DUPLICATE_ACCOUNT: 'Une erreur est survenu lors de la duplication du compte',
    ERROR_FILE_TYPE_NOT_SUPPORTED: 'Le type du fichier n\'est pas supporté',
    ERROR_GET_TABLE: 'Erreur lors de la récupération des données proxy',
    ERROR_HEADER: 'Erreur de l\'en-tête ',
    ERROR_IMPORT: 'Il y a eu un problème lors de l\'import, il est probable que vous ayez modifié le fichier sans le réimporter.\n Veuillez réimporter votre fichier',
    ERROR_IMPORT_ACCOUNT: 'Erreur lors de l\'import de l\'account.',
    ERROR_IMPORT_ACCOUNT_CHANGE: 'Vous avez sélectionné un nouveau compte, si vous continuez les combinaisons d\'en-têtes attribues réalisées précédemment seront supprimés.',
    ERROR_IMPORT_DUPLICATE_HEADER: 'Importation impossible, les en-têtes suivants sont dupliqués importation impossible : ',
    ERROR_IMPORT_HEADER_CHANGE: 'Les en-têtes du fichier ont changé, si vous continuez les combinaisons d\'en-têtes attribues réalisées précédemment seront supprimés.',
    ERROR_MSG: 'L\'attribut {name} n\'est pas correct.',
    ERROR_MSG_PASSWORD: 'Les mots de passes ne correspondent pas ou sont vide.',
    ERROR_PROXY_HOST_ALREADY_USED: 'Erreur: Ip déja utilisée',
    ERROR_RETAILER_SITE: 'Sélectionnez un site lié au compte retailer.',
    ERROR_UPDATE_ACCOUNT: 'Une erreur est survenu lors de la mise à jour du compte',
    ERROR_UPDATE_PERFORMANCE: 'Une erreur est survenu lors de la mise à jour la performance',
    ERROR_UPDATE_SITE: 'Une erreur est survenu lors de la mise à jour du site',
    ERROR_UPDATE_USER: 'Une erreur est survenu lors de la mise à jour du user',
    EXCL: 'HT',
    EXPORT_DATA: 'Export de données',
    FAILURE: 'Echec',
    FIELD_MATCH_RULES: 'Règles pour les attributs qui ont été matchés mais qui ne sont pas des clés',
    FILE_HEADER: 'En-têtes du fichier',
    FILE_NAME: 'Nom du fichier',
    FILTERS: 'Filtres',
    FIRSTNAME: 'Prénom',
    FORCE_UPDATE: 'Forcer la mise à jour',
    FROM: 'Du',
    GENDER: 'Genre',
    GENERAL_INFORMATIONS: 'Informations générales',
    GENERATE_A_SCRIPT: 'Générer le script',
    GRANULARITY: 'Agrégées par',
    GREATEST_DECREASES_IN_PERCENTAGE: 'Plus forte baisse en %',
    GREATEST_DECREASES_IN_VALUE: 'Plus forte baisse en valeur',
    GREATEST_INCREASES_IN_PERCENTAGE: 'Plus forte hausse en %',
    GREATEST_INCREASES_IN_VALUE: 'Plus forte hausse en valeur',
    HEADER: 'En-tête',
    HISTORY: 'Historique',
    HOME: 'Accueil',
    HOST: 'Host',
    HOURS: 'heures',
    ID: 'ID',
    IDENTIFIED_CATEGORIES: 'Catégories identifiées',
    IDENTIFIED_PRODUCTS: 'Produits identifiés',
    IMAP_CONFIGURATION: 'Pour activer un compte IMAP, il est impératif d\'être connecté au compte gmail d\'ADBOX :',
    IMG_URL: 'Image url',
    IMPORT: 'Importer',
    IMPORT_BRUT_DATA: 'Importer les données brut',
    IN_PROGRESS: 'En cours',
    IN_SECONDS: 'In seconds',
    INCL: 'TTC',
    INPUT_ARTICLE_RULE: 'Article en entrée sans match en base',
    INPUT_FIELD_RULES: 'Règles pour les attributs en cas de création d\'article',
    INVALID_DATE: 'Date non valide',
    INVALID_ID_FORMAT: 'Format des ids non valide',
    INVALID_PAGE_INDEX: 'Page index invalide',
    INVALID_PAGE_SIZE: 'Taille de page invalide',
    INVALID_PERIOD: 'Période non valide',
    INVALID_PROXY_COUNTRY: 'Pays de proxy non valide',
    INVALID_PROXY_TYPE: 'Type de proxy non valide',
    INVALID_SORT: 'Le trie est invalide',
    INVALID_SPE_HIGHLIGHT_STATUS: 'Le statut n\'est pas valide',
    INVALID_TOKEN: 'Le token est invalide',
    INVALID_URLS_ERROR: 'Veuillez entrer des URLs valides',
    INVALID_USER_ACTION: 'Les actions utilisateurs ne sont pas correct',
    IS_MARKET_PLACE: 'Marketplace ?',
    LANGUAGE: 'Langue',
    LAST_UPDATE: 'Dernière mise à jour',
    LASTNAME: 'Nom de famille',
    LAT: 'Latitude',
    LAUNCH_ORDER_RECOVERY: 'Lancer la récupération des numéros de commande',
    LINK_TO_ATTRIBUTE: ' associer à l\'attribut ',
    LOGIN: 'Identifiant',
    LOGIN_BUTTON: 'Se connecter',
    LOGO_URL: 'Url du logo',
    LOGOUT: 'se déconnecter',
    LONG: 'Longitude',
    MANAGE_ACOUNTS_FOR_USER: 'Gestion des comptes pour un utilisateur',
    MARKET_PLACE: 'Marketplace',
    MATCHING_HEADERS: 'Relier les en-têtes',
    MATCHING_SUMARY_ATTRIBUTE_OPTIONAL: 'Résumé des associations d\'en-tête attributs optionnel',
    MATCHING_SUMARY_ATTRIBUTE_REQUIRED: 'Résumé des associations d\'en-tête attributs requis',
    MAX_CONNECTION: 'Connections max',
    MAX_PARALLEL_WORKERS: 'Nombre de workers parallèles',
    MODIFY: 'Modifier',
    MODIFY_NAME: 'Modifier le nom',
    MODIFY_PASSWORD: 'Modifier le mot de passe',
    MODIFY_SITES_TO_SCRAP: 'Modifier les sites à scraper',
    MODULES_CONFIGURATION: 'Configuration des modules',
    MONTH: 'Mois',
    MULTIPLE_ACCOUNTS: 'Comptes multiples',
    MULTIPLE_USERS: 'Utilisateurs multiples',
    NAME: 'Nom',
    NEW: 'Nouveau',
    NEW_ACCOUNT_NAME: 'Nom du nouveau compte',
    NEW_PASSWORD: 'Nouveau mot de passe',
    NEW_USERNAME: 'Nouveau nom d\'utilisateur',
    NEXT: 'Suivant',
    NO: 'Non',
    NO_FLOAT_ERROR: 'Le délai doit être un nombre entier !',
    NO_RECORDS_FOUND: 'Aucun enregistrement trouvé',
    NO_RIGHT: 'Vous n\'avez pas les droits',
    NONE: 'Aucun',
    NOT_CONFIGURED_SITES: 'Sites non configurés',
    OF: 'de',
    ONLY_CONFIGURED_SITES: 'Ne voir que les sites configurés',
    OPEN_ALL: 'Ouvrir tout',
    OPTIONS: 'Options',
    ORDER_RETRIEVER: 'OrderRetriever',
    ORDER_SCRIPT_WARNING: '{scriptName} comporte des problèmes et n\'est pas apte à être lancé',
    PAGE_NOT_FOUND: 'Cette page n\'a pas pu être trouvée.',
    PAGE_SIZE: 'Taille de page',
    PARAMETERS: 'Paramètres',
    PARAMS_A_DIFF: 'Paramétrer un différentiel intelligent',
    PASSWORD: 'Mot de passe',
    PERF_DIALOG_TITLE: 'Aperçu du graphique performances (les couleurs ne sont pas celles du front)',
    PERFORMANCES: 'Performances',
    PLEASE_ADD_FILE: 'Veuillez ajouter un fichier',
    PLEASE_SELECT_ACCOUNT: 'Veuillez selectionner un compte',
    PREVIOUS: 'Précédent',
    PRICE: 'Prix',
    PROCESSING_TIME: 'Temps d\'éxecution',
    PROVIDER: 'Fournisseur',
    PROXIES: 'Proxies',
    PROXY_COUNTRY: 'Pays du proxy',
    PROXY_MISSING_COUNTRY: 'Pays requis',
    PROXY_MISSING_TYPE: 'Type requis',
    PROXY_SELECTOR_SUBTITLE: 'Cette fenêtre vous permet de renseigner le proxy qui sera utilisé pour la récupération du numéro de commande sur {siteName}. Si ce dernier n\'est pas renseigné, un proxy aléatoire fonctionnant sur le site sera utilisé.',
    PROXY_TYPE: 'Type du proxy',
    PURCHASING_PRICE: 'Prix d\'achat',
    QUANTITY: 'Quantité',
    REF1: 'Référence 1',
    REF2: 'Référence 2',
    REF3: 'Référence 3',
    REMOVE_URLS: 'Effacer toutes les URLs',
    RESEARCH: 'Rechercher',
    RESET: 'Réinitialiser',
    RIGHTS: 'Droits',
    ROBOT_VERSION: 'Version du robot',
    ROWS_PER_PAGE: 'Lignes par page',
    RRP: 'RRP',
    RRP_ALERT_PERCENTAGE: 'RRP pourcentage d\'alerte',
    SAVE: 'Enregistrer',
    SCRAPED_DATA_EDITOR: 'Editeur de scraped data',
    SCRAPED_PRODUCTS: 'Produits scrapés',
    SCRAPING_CONTROL_DURATION: 'Scraping control duration',
    SCRAPING_DATA_EDITOR: 'Editeur de scraping data',
    SCRAPING_GENERATOR: 'ScrapGenerator',
    SEE_ARTICLE: 'Voir l\'article',
    SEE_GRAPH: 'Voir le graphique',
    SEE_TABLE: 'Voir le tableau',
    SELECT_A_KEY: 'Choisissez une clé',
    SELECT_ACCOUNT: 'Sélectionner un compte',
    SELECT_FILE: 'Sélectionner un fichier',
    SELECT_HEADER: 'Sélectionner un en-tête',
    SEPARATOR: 'Séparateur',
    SET_ATTRIBUTES_RULES: 'Définissez les règles attributs',
    SET_ITEMS_RULES: 'Définissez les règles produits',
    SETTINGS: 'Paramètres',
    SHIPPING_COUNTRY: 'Pays de livraison',
    SIGN_IN_ERROR: 'Mot de passe ou adresse mail incorrect',
    SIGN_IN_SUCCESS: 'Vous êtes bien connecté !',
    SITE: 'Site',
    SITE_CONFIG_ADBOX_TITLE: 'Liste des emails des expediteurs associés au site',
    SITE_NAME: 'Nom du site',
    SITE_NOT_FOUND: 'Le site n\'a pas été trouvé.',
    SITES: 'Sites',
    SITES_MANAGER: 'Gestion des sites',
    SIZE: 'Taille',
    SKU: 'SKU',
    SORT: 'Tri',
    SPE_ARTICLE_RULE: 'Article en base qui ne matche aucun article en entrée',
    SPE_FIELD_RULES: 'Règles pour les attributs en base qui n\'ont eu aucun match en entrée',
    SPE_HIGHLIGHTED_ITEMS: 'Top changements prix',
    STATUS: 'Status',
    STOCK: 'Stock',
    STOCK_5_DAYS: '+5 jours',
    STOCK_FILTER_TITLE: 'Stock',
    STOCK_IN: 'En stock',
    STOCK_NO_INFORMATION: 'Stock non précisé',
    STOCK_SOLD_OUT: 'Rupture',
    STOCK_SUP_48H: 'Supérieur à 48h',
    SUCCESS: 'Succès',
    SUCCESS_ADD_ACCOUNT: 'Le compte a bien été ajouté',
    SUCCESS_ADD_PERFORMANCE: 'La performance a été ajouté avec succès',
    SUCCESS_ADD_SITE: 'Le site a bien été ajouté',
    SUCCESS_ADD_USER: 'L\'utilisateur a bien été ajouté',
    SUCCESS_COPY: 'Copié dans le presse-papier',
    SUCCESS_DELETE_PERFORMANCE: 'La performance a bien été supprimé',
    SUCCESS_DUPLICATE_ACCOUNT: 'Le compte a été dupliqué avec succès',
    SUCCESS_IMPORT_ACCOUNT: 'Le compte a été importé avec succès',
    SUCCESS_UPDATE_ACCOUNT: 'Le compte a bien été modifié',
    SUCCESS_UPDATE_PERFORMANCE: 'La performance a été mise à jour avec succès',
    SUCCESS_UPDATE_SITE: 'Le site a bien été modifié',
    SUCCESS_UPDATE_USER: 'L\'utilisateur a bien été modifié',
    SUPER_USER: 'Super utilisateur',
    TAG: 'Tag',
    TAX_MODE: 'Taxes',
    TAXES_EXCLUDED: 'HT',
    TAXES_INCLUDED: 'TTC',
    TEST_KEY: 'Tester la clé',
    TEST_THE_SCRIPT: 'Tester le script',
    TO: 'Au',
    TRUST_ALERT_THRESHOLD: 'Seuil d\'alerte',
    TYPE: 'Type',
    UNAUTHORIZED_PAGE: 'Vous n\'êtes pas autorisé à accéder à cette page.',
    UNLOCK_ALL_FIELDS: 'Déverrouiller tous les champs',
    UPDATE_PERFORMANCE: 'Modifier la performance',
    URL: 'Url',
    USER: 'Utilisateur',
    USER_ACTIONS: 'Actions des utilisateurs',
    USER_BLOCKED: 'Utilisateur bloqué',
    USERNAME: 'Nom d\'utilisateur',
    USERNAME_HAS_BEEN_CHANGED: 'Le nom d\'utilisateur a été changé',
    USERS: 'Utilisateurs',
    USERS_LIST: 'Liste des utilisateurs',
    USERS_MANAGER: 'Gestion des utilisateurs',
    VISIBLES_SITES: 'Sites visibles',
    VISIBLES_STATUS: 'Status visibles',
    WAIT: 'Temps d\'attente',
    WAITING_FOR_RESULTS: 'En attente de résultats',
    WARNING: 'Attention',
    WARNING_ACTIVATE_1: 'Si le compte a accès aux module SPE et Pricing Engine, les robots de scraping (re)commenceront à réaliser le relevé des prix ET le daily monitoring sera envoyé chaque matin.',
    WARNING_ACTIVATE_2: 'Si le compte a accès au module Slider, le slider bot (re)commencera à réaliser le relevé des bannières publicitaires.',
    WARNING_ACTIVATE_3: 'Êtes vous sûr(e) de vouloir continuer ?',
    WARNING_ACTIVATE_ACCOUNT: 'Attention, vous êtes en train de d\'activer le compte {name}',
    WARNING_DEACTIVATE_1: 'Si le compte a accès aux module SPE et Pricing Engine, les robots de scraping ne réaliseront plus le relevé des prix ET le daily monitoring ne sera plus envoyé.',
    WARNING_DEACTIVATE_2: 'Si le compte a accès au module Slider, le slider bot ne réalisera plus le relevé des bannières publicitaires.',
    WARNING_DEACTIVATE_3: 'Êtes vous sûr(e) de vouloir continuer ?',
    WARNING_DEACTIVATE_ACCOUNT: 'Attention, vous êtes en train de de désactiver le compte {name}',
    WEEKS: 'Semaines',
    YES: 'Oui'
};
export default locales;
